<template lang="pug">
el-form-item(:label="label")
  el-select(v-model="displayFieldName", v-bind="$attrs", allow-create, filterable, :disabled="widgetNameReadonly", clearable)
    el-option(v-for="(sf, sfIdx) in fieldList", :key="sfIdx", :label="sf.label", :value="sf.name")
</template>
<script>
import { subFormBus } from "../panel-setting/subFormBus";
export default {
  inject: ["serverFieldList", "designer", "getDesignerConfig", "subformFieldList", "isSubFormChildWidget"],
  inheritAttrs: false,
  props: {
    value: { default: "", type: [String, Array] },
    label: { default: "", type: String }
  },
  computed: {
    displayFieldName: {
      get() {
        return this.value;
      },
      set(newName) {
        this.$emit("input", newName || "");
      }
    },

    widgetNameReadonly() {
      return !!this.getDesignerConfig().widgetNameReadonly;
    },
    inSubform() {
      return subFormBus.isSubformJyht;
    },
    subformList() {
      return subFormBus.list;
    },
    fieldList() {
      const { inSubform } = this;
      return inSubform ? this.subformList : this.serverFieldList;
    }
  }
};
</script>
